export interface Part {
  id: string;
  name: string;
  code: string;
  icon: string;
  description?: string;
  category?: string;
  imageUrl?: string;
  available?: boolean;
  metadata?: Record<string, unknown>;
}

export interface PartsApiResponse {
  parts: Part[];
  totalParts: number;
  metadata?: {
    modelId?: string;
    version?: string;
    lastUpdated?: string;
    language?: string;
  };
}

export function generateMockParts(): Part[] {
  return [
    { id: 'arm-frame-left', name: 'Arm Frame Left', code: 'AF-L-001', icon: 'view_in_ar', category: 'Frame', available: true },
    { id: 'arm-frame-right', name: 'Arm Frame Right', code: 'AF-R-002', icon: 'view_in_ar', category: 'Frame', available: true },
    { id: 'motor-housing', name: 'Motor Housing', code: 'MH-120-A', icon: 'precision_manufacturing', category: 'Mechanical', available: true },
    { id: 'propeller-set', name: 'Propeller Set', code: 'PS-4X-09', icon: 'cycle', category: 'Flight', available: true },
    { id: 'flight-controller', name: 'Flight Controller', code: 'FC-PRO-7', icon: 'memory', category: 'Electronics', available: true },
    { id: 'power-distribution', name: 'Power Distribution Board', code: 'PDB-48V', icon: 'electric_bolt', category: 'Electrical', available: true },
    { id: 'gps-module', name: 'GPS Module', code: 'GPS-M8N', icon: 'my_location', category: 'Navigation', available: true },
    { id: 'battery-pack', name: 'Battery Pack', code: 'BP-6S-5000', icon: 'battery_full', category: 'Power', available: true },
  ];
}
